<template>
  <o-table :title="$t('core.audit_log')" url="/api/system/audit_log" ref="tableList" :enable-new="false"
           :enable-delete="false" :enable-edit="false" default-sort-by="id" default-sort-by-direction="desc">
    <template slot="filter">
      <o-filter v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)" :filter-cacheable="true">
        <o-filter-select :items="logNames" :title="$t('core.name')" column="log_name"></o-filter-select>
        <o-filter-select :items="logActions" :title="$t('core.action')" column="event"></o-filter-select>
        <o-filter-text :title="$t('sandoz.user')" column="causer"></o-filter-text>
      </o-filter>
    </template>
    <template slot="head">
      <o-table-header column="log_name">{{$t('core.name')}}</o-table-header>
      <o-table-header column="event">{{$t('core.action')}}</o-table-header>
      <o-table-header column="description">{{$t('core.description')}}</o-table-header>
      <o-table-header :sortable="false">{{$t('core.user')}}</o-table-header>
      <o-table-header column="properties">{{$t('core.data')}}</o-table-header>
      <o-table-header column="created_at">{{$t('core.date')}}</o-table-header>
    </template>
    <template slot="body" slot-scope="props">
      <td>{{ props.item.log_name }}</td>
      <td>{{ props.item.event }}</td>
      <td>{{ props.item.description }}</td>
      <td>{{ props.item.causer ? props.item.causer.name + ' (' + props.item.causer.email + ')' : null }}</td>
      <td>
        <template v-if="props.item.properties && Object.keys(props.item.properties).length">
          <template v-for="(property, column) in props.item.properties">
            {{column}}: {{property?property:''}}<br>
          </template>
        </template>
        <template v-else>-</template>
      </td>
      <td>{{ props.item.created_at | formatDatetime }}</td>
    </template>
  </o-table>
</template>

<script>

export default {
  data: () => ({
    logNames: [],
    logActions: []
  }),
  created () {
    this.logActions = [
      { value: 'Filter', text: 'Filter' },
      { value: 'Login', text: 'Login' },
      { value: 'Login - form', text: 'Login - form' },
      { value: 'Login - Impersonate', text: 'Login - Impersonate' },
      { value: 'Login Blocked', text: 'Login Blocked' },
      { value: 'Login Failed', text: 'Login Failed' },
      { value: 'Logout', text: 'Logout' }
    ]
    this.logNames = [
      { value: 'Authentication', text: 'Authentication' },
      { value: 'Bulk Delivery', text: 'Bulk Delivery' }
    ]
  }
}
</script>
